module.exports = __webpack_public_path__ + "static/media/surgery.cd2a77b6.jpg";